import React from 'react';
//images
import Logo from '../assets/logo.png';

const Header = () => {
  return (
    <header className='py-8'>
    <div className='container mx-auto'>
      <div className='flex justify-between items-center'>
        {/** logo*/}
        <a href='#'>
          <img src={Logo} className='mix-blend-lighten bg-top' height={45} width={111} alt='' />
        </a>
        {/***button */}
        <button className='btn btn-sm'>Work with me</button>

      </div>
    </div>
  </header>
  );
};

export default Header;
